import { get, put, post, del } from 'aws-amplify/api';

import { fetchAuthSession } from 'aws-amplify/auth';

const apiName = 'SUMS';
const debug = true;

async function getAgentsByLead(id, token) {
    let path = "/getAgentsByLead/" + id;
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && debug && console.log('GET Agent By Lead call succeeded: ', response);
        const filteredResponse = response.filter(agent => !agent.deleted);
        // console.log('test: ', filteredResponse.length);
        // return response;
        const sortedResponse = filteredResponse.sort((a, b) => {
            const lastNameA = (a.Lastname || '').toLowerCase();
            const lastNameB = (b.Lastname || '').toLowerCase();
            return lastNameA.localeCompare(lastNameB); // Asscending order
        });
        return sortedResponse;
    } catch (e) {
        debug && console.log('GET Agent By Lead call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

async function getStacks() {
    let path = "/settings";
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('GET Stacks call succeeded: ', response);
        return response;
    } catch (e) {
        debug && console.log('GET Stacks call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

async function getAllAgents() {
    let path = "/agent/all"
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        const filteredResponse = response.filter(agent => !agent.deleted);
        debug && console.log('GET Agents call succeeded: ', response);
        
        const sortedResponse = filteredResponse.sort((a, b) => {
            const lastNameA = (a.Lastname || '').toLowerCase();
            const lastNameB = (b.Lastname || '').toLowerCase();
            return lastNameA.localeCompare(lastNameB); // Asscending order
        });
        return sortedResponse;
    } catch (e) {
        debug && console.log('GET Agents call failed: ', JSON.parse(e.response.body));
        return e;
    }
}
export async function downloadCSV() {
    let path = "/agent/all"
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('DOWNLOAD GET Agents call succeeded: ', response);
        convertJSONtoCSV(response, 'download.csv');
        
        // const sortedResponse = filteredResponse.sort((a, b) => {
        //     const lastNameA = (a.Lastname || '').toLowerCase();
        //     const lastNameB = (b.Lastname || '').toLowerCase();
        //     return lastNameA.localeCompare(lastNameB); // Asscending order
        // });
        // return sortedResponse;
    } catch (e) {
        debug && console.log('GET Agents call failed: ', JSON.parse(e.response.body));
        return e;
    }
}
function convertJSONtoCSV(jsonData, filename = 'download.csv') {
    // Get all possible headers from all objects
    const headers = Array.from(new Set(
        jsonData.reduce((keys, obj) => {
            return keys.concat(Object.keys(obj));
        }, [])
    ));
    
    // Create CSV rows from the JSON data
    const csvRows = [];
    
    // Add the headers as first row
    csvRows.push(headers.join(','));
    
    // Add the data rows
    jsonData.forEach(item => {
        const values = headers.map(header => {
            const value = item[header];
            
            // Special handling for Stack property
            if (header === 'Stack' && typeof value === 'object') {
                // Double escape the quotes and wrap in quotes to handle commas
                const jsonString = JSON.stringify(value).replace(/"/g, '""');
                return `"${jsonString}"`;
            }
            
            // Handle null or undefined
            if (value === null || value === undefined) {
                return '""';
            }
            
            // Handle all other values
            // Escape any quotes in the value and wrap in quotes
            const stringValue = String(value).replace(/"/g, '""');
            return `"${stringValue}"`;
        });
        csvRows.push(values.join(','));
    });
    
    // Combine rows into a single string
    const csvString = csvRows.join('\n');
    
    // Create a Blob containing the CSV data
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    
    // Create a download link
    const link = document.createElement('a');
    
    // Create the URL for the blob
    const url = window.URL.createObjectURL(blob);
    
    // Set link properties
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    
    // Add link to document
    document.body.appendChild(link);
    
    // Trigger download
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}


async function getAllLeads() {
    let path = "/lead/all"
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('GET Leads call succeeded: ', response);
        const sortedResponse = response.sort((a, b) => {
            const lastNameA = (a.Lastname || '').toLowerCase();
            const lastNameB = (b.Lastname || '').toLowerCase();
            return lastNameA.localeCompare(lastNameB); // Ascending order
        });
        return sortedResponse;
    } catch (e) {
        debug && console.log('GET Leads call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

export async function Data() {
    let data = { agents: [], stacks: [], isAdmin: false };
    // get the current auth token
    let tokens = (await fetchAuthSession()).tokens ?? {};
    let user = Object.assign({}, tokens);
    let groups = tokens.idToken.payload["cognito:groups"] !== undefined ? tokens.idToken.payload["cognito:groups"] : [];
    // token = token.idToken.jwtToken;
    let token = tokens.idToken;

    debug && console.log('DEBUG GROUPS: ', groups)
    if (groups.includes("Admin")) {
        data.userName = 'Admin'
        data.isAdmin = true;
        data.userEmail = user.idToken.payload.email;
        data.stacks = await getStacks();
        // debug && console.log('stacks, ', data.stacks)
        //get leads
        data.leads = await getAllLeads();
        console.log('all leads, ', JSON.stringify(data.leads));

        //get agents 
        data.agents = await getAllAgents();

        // debug && console.log('data: ', JSON.stringify(data))

    }
    else {

        try {
            let result = await getAgentsByLead(user.idToken.payload.email, token);
            data.stacks = await getStacks();
            result.forEach(element => {
                if (element.SK === "LEAD") {
                    data.userName = element.Firstname + " " + element.Lastname;
                    data.userEmail = element.PK.split('#')[1];
                    data.stack = element.Stack;
                } else {
                    data.agents.push(element)
                }
            });
        } catch (err) {
            debug && console.log(err);
        };

        try {
            let stacks = await getStacks();
            data.stacks = stacks;
        } catch (e) {
            debug && console.log(e)
        };
    };
    return data;
}

export async function addAgent(agent) {
    let path = "/agent/save";
    const restOperation = post({
        apiName: apiName,
        path: path,
        options: {
            body: agent
        }
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('POST Agents call succeeded: ', JSON.stringify(response));
        return JSON.parse(response);
        // const response = await restOperation.response;
        // console.log('debug123: ',response)
        // debug && console.log('POST Agents call succeeded!');
        // return JSON.parse(response);

    } catch (e) {
        // debug && console.log('POST Agents call failed: ', JSON.parse(e.response));
        debug && console.log('POST Agents call failed', e);
        return e;
    }
}

export async function updateAgent(agent) {
    let path = "/agent/save";
    const restOperation = put({
        apiName: apiName,
        path: path,
        options: {
            body: agent
        }
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('PUT Agents call succeeded: ', response);
        return response;
    } catch (e) {
        debug && console.log('PUT Agents call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

export async function removeAgent(agentEmail, leadId, timestamp) {
    let path = "/agent/" + leadId + "/" + agentEmail+'+' + timestamp;
    const restOperation = del({
        apiName: apiName,
        path: path,
    });

    try {
        await restOperation.response;
        debug && console.log('DELETED Agents call succeeded');
        return 'DELETED Agents call succeeded';
    } catch (e) {
        debug && console.log('DELETE Agents call failed!' + JSON.stringify(e));
        return e;
    }
}

export async function AgentWithEmailExists(email) {
    let path = `/AgentEmailExists/${email}`;
    const restOperation = get({
        apiName: apiName,
        path: path
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('GET Agents with Email call succeeded: ', response);
        return response;
    } catch (e) {
        debug && console.log('GET Agents with Email call failed: ', JSON.parse(e));
        return e;
    }
}

export async function addLead(lead) {
    let path = '/lead/save'
    console.log('debug lead: ', lead);
    const restOperation = post({
        apiName: apiName,
        path: path,
        options: {
            body: lead
        }
    });
    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('POST Lead call succeeded: ', response);
        // debug && console.log('debug lead ', lead);
        return response;
    } catch (e) {
        debug && console.log('POST Lead call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

export async function removeLead(id) {
    let path = `/lead/${id}`;

    const restOperation = del({
        apiName: apiName,
        path: path
    });

    try {
        const { body } = await restOperation.response;
        const response = await body.json();
        debug && console.log('DELETE Lead call succeeded: ', response);
        return response;
    } catch (e) {
        debug && console.log('DELETE Lead call failed: ', JSON.parse(e.response.body));
        return e;
    }
}

export default Data;